import { createContext, useContext } from 'react';

import { DictionaryTypeDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export type DictionariesContextProps = Record<DictionaryTypeDto, SelectSearchOptionModel<string>[]>;

export const DictionariesDefaultValues: DictionariesContextProps = {
  [DictionaryTypeDto.CompetencyArea]: [],
  [DictionaryTypeDto.Department]: [],
  [DictionaryTypeDto.EmployeeAspirationInTime]: [],
  [DictionaryTypeDto.EmployeeAspirationType]: [],
  [DictionaryTypeDto.EmployeeLeavingRiskLevel]: [],
  [DictionaryTypeDto.EmployeeMobility]: [],
  [DictionaryTypeDto.EmployeePosition]: [],
  [DictionaryTypeDto.EmployeeSuccessionReadiness]: [],
  [DictionaryTypeDto.EnglishLevel]: [],
  [DictionaryTypeDto.Matrix]: [],
  [DictionaryTypeDto.Region]: [],
  [DictionaryTypeDto.TraditionalCounterShop]: [],
  [DictionaryTypeDto.UserRole]: [],
  [DictionaryTypeDto.YesNo]: [],
};
export const DictionariesContext =
  createContext<DictionariesContextProps>(DictionariesDefaultValues);

export const useDictionariesContext = (): DictionariesContextProps => {
  return useContext<DictionariesContextProps>(DictionariesContext);
};
